import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import OtpInput from '../containers/Auth/OtpInputs';
import GlassLayout from '../components/GlassLayout';
import { useHospitalContext } from '../context/HospitalContext';
import { connect } from 'react-redux';
import { store } from '../redux/store/index';
import * as loginActions from '../redux/actions/loginActions';
import { socket } from "../socket/socket";
import { useDoctor } from '../context/DoctorSelectionContext';
import { analytics, trackEvent, setAnalyticsUser } from '../utils/firebase';
import { setUserId, setUserProperties } from 'firebase/analytics';

const OtpVerification = ({ authReducer }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const phoneNumber = location.state?.phone;
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('')
    const { setSelectedHospital } = useHospitalContext()
    const countryCode = location.state?.countryCode
    const { setSelectedDoctor } = useDoctor()

    useEffect(() => {
        if (!phoneNumber) {
            // Redirect back if phone number is missing
            navigate('/');
        }

        const { status, authError, requestState, userAttributes } = authReducer;

        if (status === 'OTP Verificaiton Sucessfull') {
            //  if we got one hospital then set the hospital and move on 
            const hospitals = userAttributes?.hospitals
            const defaultHospital = hospitals.find(h => h.isDefault === true);
            const doctor = userAttributes?.doctor;
            localStorage.setItem("hospitalId", defaultHospital?.id)
            setSelectedHospital(defaultHospital)
            navigate('/dashboard')
            const token = userAttributes?.token;
            if (token) {
              localStorage.setItem("token", token);
            }
            socket.auth = {
              token,
            };
            // connect socket
            socket.connect();
            socket.on("connect", () => {
              console.log("socket connected", socket.id);
            });
            if (userAttributes.doctor) {
                localStorage.setItem("doctor", JSON.stringify(userAttributes.doctor))
                setSelectedDoctor(userAttributes.doctor)
            }
            if (analytics) {
                const userId = userAttributes?.doctor?.id || userAttributes?.id || "unknown";
                setUserId(analytics, String(userId));
                setUserProperties(analytics, {
                    doctor_id: String(doctor?.id || ''),
                    doctor_name: doctor?.name || '',
                    hospital_id: String(defaultHospital?.id || ''),
                    hospital_name: defaultHospital?.name || '',
                    role: doctor?.role || '',
                });
                setAnalyticsUser({
                    doctorId: doctor?.id,
                    doctorName: doctor?.name,
                    hospitalId: defaultHospital?.id,
                    hospitalName: defaultHospital?.name,
                    role: doctor?.role,
                });
                localStorage.setItem(
                    'analyticsUser',
                    JSON.stringify({
                        doctorId: doctor?.id,
                        doctorName: doctor?.name,
                        hospitalId: defaultHospital?.id,
                        hospitalName: defaultHospital?.name,
                        role: doctor?.role,
                    })
                );
                trackEvent('login_success', { method: 'phone' });
            }
        }
        else if (status === 'failure' && !requestState) {
            setError(authError);
        }

    }, [phoneNumber, navigate, authReducer]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (otp.length !== 6) return;
        setError('');
        store.dispatch(loginActions.authVerifySignInRequestAction(phoneNumber, process.env.REACT_APP_ONI_PLATFORM, otp, countryCode));
    };

    return (
        <GlassLayout>
                      <form onSubmit={handleSubmit}>

            <Typography variant="h4" align='center' fontWeight={'bold'}>
                Enter OTP
            </Typography>
            <Typography align='center' mt={3} sx={{ fontSize: { xs: '0.7rem', sm: '1rem' }, whiteSpace: { xs: 'nowrap', sm: 'normal' } }}>
                Enter Verification Code sent to your phone number
            </Typography>
            <Typography align="center" mb={4} fontSize={'0.85rem'}>
                {countryCode && phoneNumber ? `${countryCode}-${phoneNumber}` : ''}
                <span
                    style={{
                        cursor: 'pointer',
                        fontWeight: 500,
                        color: 'blue',
                        marginLeft: '2%'
                    }}
                    onClick={() => navigate('/')}
                >
                    Edit number
                </span>
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    mb: 2,
                }}
            >
                <OtpInput
                    value={otp}
                    valueLength={6}
                    onChange={(data) => {
                        setOtp(data)
                        if (error) setError('');
                    }}
                />
            </Box>
            {
                error && <Typography>{error}</Typography>
            }

            <Button
                type="submit" 
                variant="contained"
                fullWidth
                sx={{
                    backgroundColor: '#fbc02d',
                    color: '#ffff',
                    textTransform: 'none',
                    width: '80%',
                    fontSize: '18px',
                    '&:hover': {
                        backgroundColor: '#f9a825',
                    },
                    mt: 8,
                }}
                loading={authReducer.requestState}
            >
                Verify OTP
            </Button>

            <Typography
                variant="body2"
                mt={2}
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => store.dispatch(loginActions.authSignInRequestAction(phoneNumber, process.env.REACT_APP_ONI_PLATFORM, "+91"))}
            >
                Resend OTP
            </Typography>
            </form>
        </GlassLayout>
    );
};

const mapStateToProps = (state) => {
    const { authReducer } = state;
    return { authReducer };
};

export default connect(mapStateToProps)(OtpVerification);